import {Component} from '@angular/core';
import {IonicPage, NavController, NavParams} from 'ionic-angular';
import {SorobanBasicBoardPage} from "../soroban-basic-board/soroban-basic-board";
import {SorobanAddSubBoardPage} from "../soroban-add-sub-board/soroban-add-sub-board";
import {SorobanMultiBoardPage} from "../soroban-multi-board/soroban-multi-board";
import {SorobanDivisonBoardPage} from "../soroban-divison-board/soroban-divison-board";
import {SorobanExamPage} from "../soroban-exam/soroban-exam";

/**
 * Generated class for the SorobanBoardPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
    selector: 'page-soroban-board',
    templateUrl: 'soroban-board.html',
})
export class SorobanBoardPage {

    sorobanBasicBoardPage = SorobanBasicBoardPage;
    sorobanAddSubBoardPage = SorobanAddSubBoardPage;
    sorobanMultiBoardPage = SorobanMultiBoardPage;
    sorobanDivisionBoardPage = SorobanDivisonBoardPage;
    sorobanExamPage = SorobanExamPage;

    constructor(public navCtrl: NavController, public navParams: NavParams) {
    }

    ionViewDidLoad() {
        console.log('ionViewDidLoad SorobanBoardPage');
    }

}



// WEBPACK FOOTER //
// ./src/pages/soroban-board/soroban-board.ts